import './Profile.scss';

import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import classNames from 'classnames';

import { loadProvider } from 'actions/provider';
import FullScreenLoader from 'atoms/full-screen-loader';
import useWindowDimensions from 'hooks/useWindowDimensions';
import {
  clearOtherProviderData,
  otherProviderSuccess,
} from 'store/reducers/otherProvider';

import MobileProfile from './components/MobileProfile';
import ProfileInfoBar from './components/ProfileInfoBar';
import Services from './components/Services';
import EditServiceModal from './modals/EditServiceModal';

export default function Profile() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const params = useParams();
  const { providerSlug } = params;
  const { providerUsers } = useSelector((state) => state.user);
  const myProvider = useSelector((state) => state.provider);
  const otherProvider = useSelector((state) => state.otherProvider);
  const [isOpen, openModal] = useState(false);
  const { width } = useWindowDimensions();
  const isMobile = width <= 600;

  const isMyProvider =
    !providerSlug || providerSlug === providerUsers?.provider?.slug;
  const provider = otherProvider.uuid ? otherProvider : myProvider;
  const { locations, providerLoading: isLoading } = provider;
  const { services } = locations[0];

  useEffect(() => {
    const slug = providerSlug || providerUsers?.provider?.slug;
    const actions = !isMyProvider ? [null, otherProviderSuccess, null] : null;
    dispatch(loadProvider(slug, actions));

    return () => dispatch(clearOtherProviderData());
  }, [providerSlug]);

  const onAddService = () => {
    navigate('/add-service');
  };

  if (isLoading) return <FullScreenLoader />;

  return (
    <div className={classNames('services-page w-100 flex-row align-start')}>
      <Helmet title="Profile | PawCare" />
      {isMobile ? (
        <MobileProfile isMyProvider={isMyProvider} provider={provider} />
      ) : (
        <>
          <ProfileInfoBar isMyProvider={isMyProvider} provider={provider} />
          <div className="page-container">
            <Services
              isMyProvider={isMyProvider}
              onAddService={onAddService}
              services={services}
            />
          </div>
          <EditServiceModal isOpen={isOpen} openModal={openModal} />
        </>
      )}
    </div>
  );
}
